import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Icon } from '@panel/commons';
import { select, withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  width: 400px;
  height: 214px;
  margin: 0 auto;
  display: flex;
  background-color: ${select('white')};
  flex-flow: column nowrap;
  border-radius: 8px;
  padding: 40px;
  font-family: 'Hind';
  align-items: center;
  box-sizing: border-box;
  position: relative;
  > div.iconWrapper {
    position: absolute;
    &:hover {
      cursor: pointer;
    }
    top: 22px;
    right: 22px;
  }
  > h4 {
    font-size: 20px;
    line-height: 26px;
  }
  > div.message {
    font-size: 16px;
    line-height: 25px;
    color: ${select('darkGray')};
    margin: 5px auto 20px;
    ${withQuery.md.down()} {
      margin-bottom: 30px;
    }
  }
  ${withQuery.md.down()} {
    max-width: 86%;
    margin: 0 auto;
    margin-top: 35vh;
  }
`;

const CTAButton = styled.button`
  display: block;
  margin: 0 auto;
  width: 176px;
  height: 48px;
  padding: 13px 15px;
  background: ${getColor('primary')};
  border-radius: 12px;
  color: ${select('white')};
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  border-radius: 12px;
  &:hover {
    cursor: pointer;
  }
`;

function SeekerErrorModal({ onClose }) {
  const { t } = useTranslation();
  return (
    <Container data-repa='seeker-errorModal'>
      <div
        data-repa='seeker-errorModal-icon'
        className='iconWrapper'
        role='button'
        tabIndex='0'
        aria-hidden='true'
        onClick={onClose}
      >
        <Icon name='close' colorFill='black' />
      </div>
      <h4 data-repa='seeker-errorModal-title'>{t('publisher.form.convertseeker.error.title')}</h4>
      <div className='message' data-repa='seeker-errorModal-msg'>
        {t('publisher.form.convertseeker.error.subtitle')}
      </div>
      <CTAButton data-repa='seeker-errorModal-CTA' onClick={onClose}>
        {t('publisher.form.convertseeker.error.cta')}
      </CTAButton>
    </Container>
  );
}

export { SeekerErrorModal };
